import { Component, OnInit } from '@angular/core';
import * as basicLightbox from 'basiclightbox';
import * as $ from 'jquery';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { NgxSpinnerService } from 'ngx-spinner';
import { DeleterService } from 'src/app/shared/deleter.service';
import { UploaderService } from 'src/app/shared/uploader.service';
import { GlobalConstants } from '../../shared/global-constants';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalCallejeroNumeroClientesComponent } from '../modal-callejero-numero-clientes/modal-callejero-numero-clientes.component';


@Component({
  selector: 'app-modal-numero-clientes',
  templateUrl: './modal-numero-clientes.component.html',
  styleUrls: ['./modal-numero-clientes.component.scss']
})
export class ModalNumeroClientesComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ModalCallejeroNumeroClientesComponent>,
  ) { }

  ngOnInit(): void {
  }

  modalCallejeroMostrarNumeroCliente() {
    const childDialogRef = this.dialog.open(ModalCallejeroNumeroClientesComponent);
    
    childDialogRef.afterClosed().subscribe(result => {
      if (result || result === 'childClosed') {
        this.dialogRef.close(result);
      }
    });
  }

}
